<template>
	<v-app>
		<core-system-app-bar />
		<core-system-drawer />
		<core-view />
		<core-tenant-footer />
		<snackbar />
		<expired-snackbar />
	</v-app>
</template>

<script>
export default {
	middleware: ['setRedirect'],
	props: {
		source: String,
	},
	data: () => ({
		drawer: null,
	}),
	components: {
		CoreSystemDrawer: () => import('@/components/core/systemadmin/Drawer'),
		CoreSystemAppBar: () => import('@/components/core/systemadmin/AppBar'),
		CoreView: () => import('@/components/core/default/View'),
		CoreTenantFooter: () => import('@/components/core/default/Footer'),
		Snackbar: () => import('@/components/core/Snackbar'),
		ExpiredSnackbar: () => import('@/components/core/ExpiredSnackbar'),
	},
};
</script>
